import { useEffect, useState } from 'react'
import clsx from 'clsx'

interface CopyButtonProps {
  hovered: boolean
  content: string
  size?: number
}

export function CopyButton({ hovered, content, size = 6 }: CopyButtonProps) {
  const [{ state, i }, setState] = useState({ state: 'idle', i: 0 })

  useEffect(() => {
    if (state === 'copied') {
      const handle = window.setTimeout(() => {
        setState({ state: 'idle', i: i + 1 })
      }, 1500)
      return () => {
        window.clearTimeout(handle)
      }
    }
  }, [state, i])

  return (
    <button
      type="button"
      className={clsx(
        state == 'copied'
          ? 'text-sky-400'
          : 'text-slate-500 hover:text-slate-400',
        hovered ? '' : '',
        'relative bottom-[1px]'
      )}
      onClick={() => {
        navigator.clipboard
          .writeText(content)
          .then(() => {
            setState({ state: 'copied', i: i + 1 })
          })
          .catch((error) => {
            console.error('Failed to copy text: ', error)
          })
      }}
    >
      {state == 'copied' && (
        <svg
          className="mb-[2px] fill-green-500"
          width="16"
          height="11"
          viewBox="0 0 16 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M14.7813 1.21873C15.0751 1.51248 15.0751 1.98748 14.7813 2.2781L6.53135 10.5312C6.2376 10.825 5.7626 10.825 5.47197 10.5312L1.21885 6.28123C0.925098 5.98748 0.925098 5.51248 1.21885 5.22185C1.5126 4.93123 1.9876 4.9281 2.27822 5.22185L5.99697 8.9406L13.7188 1.21873C14.0126 0.924976 14.4876 0.924976 14.7782 1.21873H14.7813Z"></path>
        </svg>
      )}
      {state == 'idle' && (
        <svg
          fill="none"
          viewBox="0 0 512 512"
          strokeWidth="1.5"
          stroke="currentColor"
          className={`h-${size} w-${size} fill-white/40 hover:fill-white/60 `}
          onClick={() => {
            navigator.clipboard
              .writeText(content)
              .then(() => {
                setState({ state: 'copied', i: i + 1 })
              })
              .catch((error) => {
                console.error('Failed to copy text: ', error)
              })
          }}
        >
          <path d="M64 464l224 0c8.8 0 16-7.2 16-16l0-64 48 0 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l64 0 0 48-64 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM224 304l224 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16L224 48c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zm-64-16l0-224c0-35.3 28.7-64 64-64L448 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64z" />
        </svg>
      )}
    </button>
  )
}
